import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { StaticImage } from "gatsby-plugin-image";

function Tamreenitestimonials() {
  return (
    <section className="tamreeni-testimonials kinekt-testimonials p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2 className="head-h2-kinekt">
              Client’s <span style={{ color: "#20A2BE" }}>Testimonial</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-4 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2,
                },
                1366: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="tamreeni-test"
            >
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Laura Bennett,</span>
                      <h5>Healthcare Provider</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Kinekt simplified how patients schedule and communicate with
                    us. We're now more responsive, and patient satisfaction is
                    higher.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Michael Lee.,</span>
                      <h5>Wellness Expert</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Using Kinekt transformed our client interactions. Booking
                    and feedback have never been easier, significantly enhancing
                    our customer relationships.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Emily Garcia.,</span>
                      <h5>Clinic Manager</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    With Kinekt, managing appointments is seamless, and
                    gathering patient feedback is straightforward. Our clients
                    regularly comment on how much smoother their experience is
                    now.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>James Carter,</span>
                      <h5>Health Professional</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Kinekt has dramatically improved how we track client
                    preferences and reviews, enabling us to consistently offer
                    better care.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Laura Bennett,</span>
                      <h5>Healthcare Provider</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Kinekt simplified how patients schedule and communicate with
                    us. We're now more responsive, and patient satisfaction is
                    higher.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Michael Lee.,</span>
                      <h5>Wellness Expert</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Using Kinekt transformed our client interactions. Booking
                    and feedback have never been easier, significantly enhancing
                    our customer relationships.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>Emily Garcia.,</span>
                      <h5>Clinic Manager</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    With Kinekt, managing appointments is seamless, and
                    gathering patient feedback is straightforward. Our clients
                    regularly comment on how much smoother their experience is
                    now.
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-main-box">
                  <div className="test-flex">
                    <div className="testi-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="25"
                        fill="none"
                        viewBox="0 0 34 25"
                      >
                        <path
                          fill="#fff"
                          d="M31.394.63h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2zm-19.2 0h-7.2l-4.8 9.6v14.4h14.4v-14.4h-7.2z"
                        ></path>
                      </svg>
                    </div>
                    <div className="testi-content">
                      <span>James Carter,</span>
                      <h5>Health Professional</h5>
                    </div>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="166"
                        height="30"
                        fill="none"
                        viewBox="0 0 166 30"
                      >
                        <path
                          fill="#37BBA2"
                          d="m5.93 29.39 2.386-10.666-8.001-7.173 10.57-.949L14.998.545l4.11 10.057 10.571.95-8.001 7.172 2.385 10.665-9.065-5.655zM73.786 29.39l2.386-10.666-8.002-7.173 10.571-.949L82.851.545l4.112 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655zM39.858 29.39l2.386-10.666-8.001-7.173 10.57-.949L48.924.545l4.111 10.057 10.57.95-8 7.172L57.99 29.39l-9.066-5.655zM107.714 29.39l2.386-10.666-8.001-7.173 10.57-.949L116.78.545l4.111 10.057 10.571.95-8.002 7.172 2.386 10.665-9.066-5.655zM141.643 29.39l2.386-10.666-8.002-7.173 10.571-.949L150.709.545l4.111 10.057 10.57.95-8.001 7.172 2.386 10.665-9.066-5.655z"
                        ></path>
                      </svg>
                    </div>
                    <div className="num">(5.0)</div>
                  </div>
                  <p>
                    Kinekt has dramatically improved how we track client
                    preferences and reviews, enabling us to consistently offer
                    better care.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Tamreenitestimonials;
